import { render, staticRenderFns } from "./GestioneServizi.vue?vue&type=template&id=68bd6115&"
import script from "./GestioneServizi.vue?vue&type=script&lang=js&"
export * from "./GestioneServizi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports